










import { Component, Prop, Vue } from 'vue-property-decorator';
import Loader from '@/components/Loader.vue';

@Component({
  components: { Loader },
})
export default class LoadableContainer extends Vue {
  @Prop()
  loading: string;

  @Prop({ default: 'xl' })
  size: string;
}
